import ngeohash from 'ngeohash'

const MAX_GEOHASHES_LEGACY = 16
const MAX_GEOHASHES_PINS = 48

function geohashesForBoundsAtPrecision(
  bounds: { south: number; west: number; north: number; east: number },
  center: { lat: number; lng: number },
  precision: 6 | 8,
  max: number,
): string[] {
  let hashes: string[]
  try {
    hashes = ngeohash.bboxes(bounds.south, bounds.west, bounds.north, bounds.east, precision)
  } catch {
    hashes = [ngeohash.encode(center.lat, center.lng, precision)]
  }

  const re =
    precision === 6
      ? /^[0-9bcdefghjkmnpqrstuvwxyz]{6}$/
      : /^[0-9bcdefghjkmnpqrstuvwxyz]{8}$/
  const unique = Array.from(new Set(hashes.filter((h) => re.test(h))))
  if (unique.length === 0) return [ngeohash.encode(center.lat, center.lng, precision)]
  if (unique.length <= max) return unique

  return unique
    .map((hash) => {
      const decoded = ngeohash.decode(hash)
      const dLat = decoded.latitude - center.lat
      const dLng = decoded.longitude - center.lng
      return { hash, dist2: dLat * dLat + dLng * dLng }
    })
    .sort((a, b) => a.dist2 - b.dist2)
    .slice(0, max)
    .map((x) => x.hash)
}

/** Classic area search — geohash-8 cells (max 16). */
export function geohashesForBounds(
  bounds: { south: number; west: number; north: number; east: number },
  center: { lat: number; lng: number },
): string[] {
  return geohashesForBoundsAtPrecision(bounds, center, 8, MAX_GEOHASHES_LEGACY)
}

/** Pins area search — geohash-6 cells (max 48). */
export function geohashes6ForBounds(
  bounds: { south: number; west: number; north: number; east: number },
  center: { lat: number; lng: number },
): string[] {
  return geohashesForBoundsAtPrecision(bounds, center, 6, MAX_GEOHASHES_PINS)
}
